import { render } from "./FormularioBlocoAvaliacao.vue?vue&type=template&id=26cc6484&scoped=true"
import script from "./FormularioBlocoAvaliacao.vue?vue&type=script&lang=js"
export * from "./FormularioBlocoAvaliacao.vue?vue&type=script&lang=js"

import "./FormularioBlocoAvaliacao.vue?vue&type=style&index=0&id=26cc6484&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26cc6484"]])

export default __exports__